/** Where the chosen theme is kept; the page's boot script reads it before the first paint. */
export const THEME_STORAGE_KEY = 'slotwise-landing-theme';
